export default __webpack_public_path__ + "static/media/Background_00226.24389c34.png";